import React from 'react';
import { useTranslation } from 'react-i18next';
import { Disclosure, InfoDialog } from 'components/Dialog';
import { TAB_LABOR_RATE_SELECTION, TAB_PARTS_SELECTION } from 'domains/easyBasket/EasyBasket.types';
import { BlackButton, Flex, WhiteButton } from 'UI';

interface TotalStripDialogProps {
  tab: typeof TAB_PARTS_SELECTION | typeof TAB_LABOR_RATE_SELECTION;
  disclosure: Disclosure;
  onClose: () => void;
  onClickNext: () => void;
}

export const TotalStripDialog = ({ tab, disclosure, onClose, onClickNext }: TotalStripDialogProps) => {
  const { t } = useTranslation();

  const getTitle = () => {
    if (tab === TAB_PARTS_SELECTION) {
      return t('catalog.easy_basket.total_strip.dialog.title', 'Missing parts for this operation');
    } else {
      return t('catalog.easy_basket.total_strip.dialog_labor_time.title', 'Missing Labor Time for this operation');
    }
  };

  return (
    <InfoDialog
      disclosure={disclosure}
      title={getTitle()}
      description={t('catalog.easy_basket.total_strip.dialog.description', 'Do you wish to proceed?')}
      status={'info'}
      content={
        <Flex minWidth={400} direction={'row'} justify={'space-evenly'}>
          <WhiteButton onClick={onClose}>
            <Flex minWidth={80} justify={'center'}>
              {t('common.action.cancel', 'Cancel')}
            </Flex>
          </WhiteButton>
          <BlackButton
            onClick={() => {
              onClose();
              onClickNext();
            }}
          >
            <Flex minWidth={80} justify={'center'}>
              {t('common.action.continue', 'Continue')}
            </Flex>
          </BlackButton>
        </Flex>
      }
      handleConfirm={() => undefined}
    />
  );
};
